// Action Types

export const Types = {
  GET_ACTIVITIES_REQUESTED: 'admin/GET_ACTIVITIES_REQUESTED',
  GET_ACTIVITIES_SUCCEEDED: 'admin/GET_ACTIVITIES_SUCCEEDED',
  GET_ACTIVITIES_FAILED: 'admin/GET_ACTIVITIES_FAILED',

  GET_DEPARTMENTS_REQUESTED: 'admin/GET_DEPARTMENTS_REQUESTED',
  GET_DEPARTMENTS_SUCCEEDED: 'admin/GET_DEPARTMENTS_SUCCEEDED',
  GET_DEPARTMENTS_FAILED: 'admin/GET_DEPARTMENTS_FAILED',

  GET_SECTORS_REQUESTED: 'admin/GET_SECTORS_REQUESTED',
  GET_SECTORS_SUCCEEDED: 'admin/GET_SECTORS_SUCCEEDED',
  GET_SECTORS_FAILED: 'admin/GET_SECTORS_FAILED',

  GET_PROJECTS_REQUESTED: 'admin/GET_PROJECTS_REQUESTED',
  GET_PROJECTS_SUCCEEDED: 'admin/GET_PROJECTS_SUCCEEDED',
  GET_PROJECTS_FAILED: 'admin/GET_PROJECTS_FAILED',

  GET_DOCUMENTS_REQUESTED: 'admin/GET_DOCUMENTS_REQUESTED',
  GET_DOCUMENTS_SUCCEEDED: 'admin/GET_DOCUMENTS_SUCCEEDED',
  GET_DOCUMENTS_FAILED: 'admin/GET_DOCUMENTS_FAILED',

  GET_LEGAL_ENTITIES_REQUESTED: 'admin/GET_LEGAL_ENTITIES_REQUESTED',
  GET_LEGAL_ENTITIES_SUCCEEDED: 'admin/GET_LEGAL_ENTITIES_SUCCEEDED',
  GET_LEGAL_ENTITIES_FAILED: 'admin/GET_LEGAL_ENTITIES_FAILED',

  GET_INDIVIDUALS_REQUESTED: 'admin/GET_INDIVIDUALS_REQUESTED',
  GET_INDIVIDUALS_SUCCEEDED: 'admin/GET_INDIVIDUALS_SUCCEEDED',
  GET_INDIVIDUALS_FAILED: 'admin/GET_INDIVIDUALS_FAILED',

  GET_SERVICES_REQUESTED: 'admin/GET_SERVICES_REQUESTED',
  GET_SERVICES_SUCCEEDED: 'admin/GET_SERVICES_SUCCEEDED',
  GET_SERVICES_FAILED: 'admin/GET_SERVICES_FAILED',
}

// Action Creators

export function getActivities() {
  return {
    type: Types.GET_ACTIVITIES_REQUESTED,
  }
}

export function getDepartments() {
  return {
    type: Types.GET_DEPARTMENTS_REQUESTED,
  }
}

export function getSectors() {
  return {
    type: Types.GET_SECTORS_REQUESTED,
  }
}

export function getProjects() {
  return {
    type: Types.GET_PROJECTS_REQUESTED,
  }
}

export function getDocuments() {
  return {
    type: Types.GET_DOCUMENTS_REQUESTED,
  }
}

export function getLegalEntities() {
  return {
    type: Types.GET_LEGAL_ENTITIES_REQUESTED,
  }
}

export function getIndividuals() {
  return {
    type: Types.GET_INDIVIDUALS_REQUESTED,
  }
}

export function getServices() {
  return {
    type: Types.GET_SERVICES_REQUESTED,
  }
}

// Reducer

const INITIAL_STATE = {
  getActivitiesIsLoading: false,
  getActivitiesError: null,
  activities: [],

  getDepartmentsIsLoading: false,
  getDepartmentsError: null,
  departments: [],

  getSectorsIsLoading: false,
  getSectorsError: null,
  sectors: [],

  getProjectsIsLoading: false,
  getProjectsError: null,
  projects: [],

  getDocumentsIsLoading: false,
  getDocumentsError: null,
  documents: [],

  getLegalEntitiesIsLoading: false,
  getLegalEntitiesError: null,
  legalEntities: [],

  getIndividualsIsLoading: false,
  getIndividualsError: null,
  individuals: [],

  getServicesIsLoading: false,
  getServicesError: null,
  services: [],
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_ACTIVITIES_REQUESTED:
      return {
        ...state,
        getActivitiesIsLoading: true,
      }
    case Types.GET_ACTIVITIES_SUCCEEDED:
      return {
        ...state,
        getActivitiesIsLoading: false,
        getActivitiesError: null,
        activities: action.payload,
      }
    case Types.GET_ACTIVITIES_FAILED:
      return {
        ...state,
        getActivitiesIsLoading: false,
        getActivitiesError: action.payload,
        activities: [],
      }

    case Types.GET_DEPARTMENTS_REQUESTED:
      return {
        ...state,
        getDepartmentsIsLoading: true,
      }
    case Types.GET_DEPARTMENTS_SUCCEEDED:
      return {
        ...state,
        getDepartmentsIsLoading: false,
        getDepartmentsError: null,
        departments: action.payload,
      }
    case Types.GET_DEPARTMENTS_FAILED:
      return {
        ...state,
        getDepartmentsIsLoading: false,
        getDepartmentsError: action.payload,
        departments: [],
      }

    case Types.GET_SECTORS_REQUESTED:
      return {
        ...state,
        getSectorsIsLoading: true,
      }
    case Types.GET_SECTORS_SUCCEEDED:
      return {
        ...state,
        getSectorsIsLoading: false,
        getSectorsError: null,
        sectors: action.payload,
      }
    case Types.GET_SECTORS_FAILED:
      return {
        ...state,
        getSectorsIsLoading: false,
        getSectorsError: action.payload,
        sectors: [],
      }

    case Types.GET_PROJECTS_REQUESTED:
      return {
        ...state,
        getProjectsIsLoading: true,
      }
    case Types.GET_PROJECTS_SUCCEEDED:
      return {
        ...state,
        getProjectsIsLoading: false,
        getProjectsError: null,
        projects: action.payload,
      }
    case Types.GET_PROJECTS_FAILED:
      return {
        ...state,
        getProjectsIsLoading: false,
        getProjectsError: action.payload,
        projects: [],
      }

    case Types.GET_DOCUMENTS_REQUESTED:
      return {
        ...state,
        getDocumentsIsLoading: true,
      }
    case Types.GET_DOCUMENTS_SUCCEEDED:
      return {
        ...state,
        getDocumentsIsLoading: false,
        getDocumentsError: null,
        documents: action.payload,
      }
    case Types.GET_DOCUMENTS_FAILED:
      return {
        ...state,
        getDocumentsIsLoading: false,
        getDocumentsError: action.payload,
        documents: [],
      }

    case Types.GET_LEGAL_ENTITIES_REQUESTED:
      return {
        ...state,
        getLegalEntitiesIsLoading: true,
      }
    case Types.GET_LEGAL_ENTITIES_SUCCEEDED:
      return {
        ...state,
        getLegalEntitiesIsLoading: false,
        getLegalEntitiesError: null,
        legalEntities: action.payload,
      }
    case Types.GET_LEGAL_ENTITIES_FAILED:
      return {
        ...state,
        getLegalEntitiesIsLoading: false,
        getLegalEntitiesError: action.payload,
        legalEntities: [],
      }

    case Types.GET_INDIVIDUALS_REQUESTED:
      return {
        ...state,
        getIndividualsIsLoading: true,
      }
    case Types.GET_INDIVIDUALS_SUCCEEDED:
      return {
        ...state,
        getIndividualsIsLoading: false,
        getIndividualsError: null,
        individuals: action.payload,
      }
    case Types.GET_INDIVIDUALS_FAILED:
      return {
        ...state,
        getIndividualsIsLoading: false,
        getIndividualsError: action.payload,
        individuals: [],
      }

    case Types.GET_SERVICES_REQUESTED:
      return {
        ...state,
        getServicesIsLoading: true,
      }
    case Types.GET_SERVICES_SUCCEEDED:
      return {
        ...state,
        getServicesIsLoading: false,
        getServicesError: null,
        services: action.payload,
      }
    case Types.GET_SERVICES_FAILED:
      return {
        ...state,
        getServicesIsLoading: false,
        getServicesError: action.payload,
        services: [],
      }

    default:
      return state
  }
}
